<template>
  <div class="home">
    <div>
      <div class="input">
      <input type="text" class="text" v-model="value" placeholder="请输入快递单号 ">
      <div class="close-icon" @click="value=''"></div>
      <div class="search-icon" @click="search"></div>
      </div>
    </div>
    <div class="searchResult">
      <div class="res-title">
          <div class="time">时间</div>
          <div class="info">地点和跟踪进度</div>
      </div>
      <div class="result-item" v-for="item,index in data" :key="index">
        <div class="time">{{item.time}}</div>
        <div class="info">{{item.status}}</div>
      </div>
    </div>
  </div>
</template>



<script>
// @ is an alias to /src
import axios from 'axios'

export default {
  name: 'Home',
  data:function(){
    return{
      value:"",
      data:[]
    }
  },
  methods:{
    async search(){
      // 手机号后四位
      let phoneNum = '6029'
      let httpUrl = `https://qyexpress.market.alicloudapi.com/composite/queryexpress?mobile=${phoneNum}&number=${this.value}`
      let config = {
        headers:{
          "Authorization":"APPCODE 1153fde779fa4eb69a59c0301d961062"
        }
      }
      let res = await axios.get(httpUrl,config)
      let data = res.data.data.list
      this.data = data
      console.log(this.data)
    }
  }
}
</script>

<style lang="scss">
html{
  font-size: calc(100vw/3.75);
}
body{
  font-size: 0.16rem;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", Verdana, arial, sans-serif;
}
@mixin background-image($url){
  background-image: url($url);
  background-size: 100% auto;
  background-repeat: no-repeat;
}
@mixin res{
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      // align-items: center;

      .time{
        width: 0.96rem;
        text-align: center;
      }
      .info{
        width: 2.74rem;
      }
    }
.home{
  @include background-image("../assets/topbanner.png");
  width: 100%;
  height: 100vh;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  .input{
    width: 3.55rem;
    height: 0.48rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 0.1rem;
    box-shadow: 0 1px 10px #ccc;
    margin-top: 0.92rem;

    .text{
      flex: 1;
      // height: 100%;
      border: none;
      outline: none;
      font-size: 0.16rem;
      padding: 0 0.2rem;
    }
    .close-icon{
      width: 0.20rem;
      height: 0.20rem;
      padding: 0 0.03rem;
      @include background-image('../assets/cancel.png');
      background-size: 80% auto;
      border-right: 1px solid #ccc;
    }
    .search-icon{
      width: 0.26rem;
      height: 0.26rem;
      margin: 0 0.08rem;
      @include background-image('../assets/search.png')
    }
  }
  .searchResult{
    flex: 1;
    width: 95%;
    margin-top: 0.1rem;
    font-size: 0.15rem;
    // padding: 0 0.2rem; 
    .res-title{
      height: 0.4rem;
      align-items: center;
      @include res;
      .info{
        text-align: center;
      }
    }
    .result-item{
      @include res;
      .time{
        font-size: 0.12rem;
      }
      margin-bottom: 0.3rem;
    }
  }
}

</style>